<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      width="700px"
      :title="$l('tips_select_related_container') || '选择关联分柜'"
      :close-on-click-modal="false"
      :before-close="() => close()"
      append-to-body
      v-el-dialog-drag
    >
      <Main
        ref="main"
        :shipmentCode="shipmentCode"
        :shipmentBookingCode="shipmentBookingCode"
        :containers="containers"
        @checkbox-change="(rows) => (checkedRows = rows)"
      />
      <span slot="footer">
        <el-button size="small" @click="close()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>

        <el-button type="primary" size="small" @click="confirm()">
          {{ $l('btn_confirm_select_container') || '确认选择' }}
          <span> ({{ checkedCount }}) </span>
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Main from './main.vue'

export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    shipmentCode: { type: String, default: '' },
    shipmentBookingCode: { type: String, default: '' },
    containers: { type: Array, default: () => [] },
  },
  data() {
    return {
      checkedRows: [],
    }
  },
  computed: {
    checkedCount() {
      return this.checkedRows.length
    },
  },
  methods: {
    close() {
      this.checkedRows = []

      this.$emit('update:visible', false)
      this.$emit('close')
    },
    confirm() {
      if (!this.checkedCount) {
        this.$message({ message: this.$l('tips_select_container_required') || '请选择需要添加的货柜', type: 'warning' })
        return
      }

      this.$emit('confirm', this.checkedRows)
      this.close()
    },
  },
}
</script>
